import React from "react";
import { styled } from "@mui/material/styles";
import { Button, Grid } from "@mui/material";
import { useSimilarCasesData } from "components/CaseManagement/SimilarCases/SimilarCasesContext";
import PropTypes from "prop-types";

export function SimilarCasesFilters() {
  const { currentStatus, setCurrentStatus } = useSimilarCasesData();

  const updateStatus = name => {
    if (name !== currentStatus) setCurrentStatus(name);
  };

  return (
    <FiltersWrapper
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <FilterButton
        name="All"
        currentStatus={currentStatus}
        updateStatus={updateStatus}
      />
      <FilterButton
        name="Open"
        currentStatus={currentStatus}
        updateStatus={updateStatus}
      />
      <FilterButton
        name="Closed"
        currentStatus={currentStatus}
        updateStatus={updateStatus}
      />
    </FiltersWrapper>
  );
}

function FilterButton({ name, currentStatus, updateStatus }) {
  return (
    <StyledButton
      variant={currentStatus === name ? "contained" : "text"}
      color="primary"
      data-qa={`CP-Button-filter-${name.toLowerCase()}-similar-cases`}
      aria-label={`Filter to ${name.toLowerCase()} similar cases`}
      disableElevation
      disableRipple
      size="small"
      onClick={() => updateStatus(name)}
      name={name}
    >
      {name}
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  text-transform: none;
  padding: 0;
  margin-right: 10px;
  background-color: ${props => (props.name === "Open" ? "#BAE9CA" : "")};
`;

const FiltersWrapper = styled(Grid)`
  padding-bottom: ${props => props.theme.spacing(2)};
  margin-right: ${props => props.theme.spacing(2)};
`;

FilterButton.propTypes = {
  name: PropTypes.string,
  currentStatus: PropTypes.string,
  updateStatus: PropTypes.func
};
